import React from "react";

export const TwitterFilled = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 4C7.134 4 4 7.134 4 11V39C4 42.866 7.134 46 11 46H39C42.866 46 46 42.866 46 39V11C46 7.134 42.866 4 39 4H11ZM13.0859 13H21.0234L26.6602 21.0098L33.5 13H36L27.7891 22.6133L37.9141 37H29.9785L23.4375 27.707L15.5 37H13L22.3086 26.1035L13.0859 13ZM16.9141 15L31.0215 35H34.0859L19.9785 15H16.9141Z"
        fill="currentColor"
      />
    </svg>
  );
};
